import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Fügt Tailwind-Klassen zusammen und löst Konflikte auf: die zuletzt
 * angegebene Klasse gewinnt.
 *
 * @example
 * ```ts
 * cn('px-2 py-1', isActive && 'bg-primary', className)
 * ```
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
